export default __webpack_public_path__ + "static/media/pickup-small-icon.c61279ec.svg";